import settingsSvg from 'assets/icons/settings.svg';
import barchartSvg from 'assets/icons/bar_chart.svg';
import bullhornSvg from 'assets/icons/bullhorn.svg';
import creativesSvg from 'assets/icons/creatives.svg';
import clipboardSvg from 'assets/icons/clipboard.svg';
import availabilitySvg from 'assets/icons/availability.svg';
import { NAVIGATION_PATHS } from 'consts/navigation';

export const MENU_ITEMS = {
  DEAL_MANAGEMENT: {
    id: 1,
    icon: bullhornSvg,
    isDisable: false,
    displayBadge: false,
    tooltip: 'View campaigns',
  },
  CONTENT_MANAGEMENT: {
    id: 2,
    icon: creativesSvg,
    isDisable: false,
    displayBadge: true,
    tooltip: 'Content management',
    navigationPath: NAVIGATION_PATHS.CONTENT_MANAGEMENT,
  },
  INSIGHTS: {
    id: 3,
    icon: barchartSvg,
    isDisable: false,
    displayBadge: false,
    tooltip: 'Insights',
    navigationPath: NAVIGATION_PATHS.INSIGHTS,
  },
  ADMINISTRATION: {
    id: 5,
    icon: clipboardSvg,
    isDisable: false,
    displayBadge: false,
    tooltip: 'Administration',
    navigationPath: NAVIGATION_PATHS.ADMINISTRATION,
  },
  INVENTORY_MANAGEMENT: {
    id: 6,
    icon: settingsSvg,
    isDisable: false,
    displayBadge: false,
    tooltip: 'Inventory management',
    navigationPath: NAVIGATION_PATHS.INVENTORY_MANAGEMENT,
  },
  AVAILABILITY_REPORT: {
    id: 8,
    icon: availabilitySvg,
    isDisable: false,
    displayBadge: false,
    tooltip: 'Availability report',
    navigationPath: NAVIGATION_PATHS.AVAILABILITY_REPORT,
  },
};
